import React from 'react'

function HospitalAuditTrails() {
  return (
    <div>Audit Trails (who changed what)</div>
  )
}

export default HospitalAuditTrails